//encode the string to utf-8
const utf8Encoder = (str) => {
    return encodeURIComponent(str);
};

export default utf8Encoder;